// @ts-strict-ignore
import { AfterViewInit, Component, HostBinding, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { LMGlobalPersonalizationService } from '@app/states';
import { SohoBusyIndicatorDirective, SohoDropDownComponent } from 'ids-enterprise-ng';
import { LMErrorUtilService, LMFormatUtilService, LMLoggerService } from '@app/services';
import { LMListDropdownService } from '@components/lmlistdropdown/lm-list-dropdown.service';


@Component({
  selector:    'lm-list-dropdown',
  standalone: false,
  templateUrl: 'lm-list-dropdown.component.html',
  styleUrls: [ 'lm-list-dropdown.component.scss' ],
})

export class LMListDropdownComponent implements OnInit, AfterViewInit, OnDestroy  {
  @ViewChild(SohoDropDownComponent) dropdown: SohoDropDownComponent;
  @ViewChild(SohoBusyIndicatorDirective) _busyIndicator: SohoBusyIndicatorDirective;

  @HostBinding('class.is-compact-form-layout') useCompactFormLayout: boolean;

  @Input() options: LMListDropdownOptions;
  @Input() readonly: boolean;

  id: string;
  values: Array<string> = new Array<string>();
  states: Array<LMStateValue> = new Array<LMStateValue>()
  isInAccessibilityMode: boolean;
  sohoReloadStyle: SohoDropDownReloadStyles;

  constructor(
    private lmGlobalPersonalizationService: LMGlobalPersonalizationService,
    private lmLoggerService: LMLoggerService,
    private lmFormatUtilService: LMFormatUtilService,
    private lmErrorUtilService: LMErrorUtilService,
    private lmMultiValueLookService: LMListDropdownService) {
  }

  ngOnInit(): void {
    this.useCompactFormLayout = this.lmGlobalPersonalizationService.getGlobalPersonalization().useCompactFormLayout;
    this.isInAccessibilityMode = this.lmGlobalPersonalizationService.getAccessibilityMode();
    this.sohoReloadStyle = 'typeahead';
  }

  ngAfterViewInit(): void {

  }

  ngOnDestroy(): void {

  }

  set busyIndicator(value: boolean) {
    if (this._busyIndicator) {
      this._busyIndicator.activated = value;
    }
  }

  onChanged(event: Event) {
  }

  onDirty(event: Event) {

  }

  onPristine(event: Event) {

  }

  onAfterResetDirty(event: Event) {

  }

  trackByValue(index: number, state: LMStateValue) {
    return state.value;
  }

  source = (response: any, searchTerm: string) => {
    this.updateSource(response, searchTerm);
  }

  private updateSource(response: any, searchTerm: string) {
    this.busyIndicator = true;
    this.lmMultiValueLookService.fetchData(this.options, searchTerm).subscribe(dataResponse => {
      if (dataResponse?.status === 'Completed') {
        this.handleDataResponse(dataResponse);
        setTimeout(() => {
          if (typeof response === 'function') {
                // true indicates to sohoxi dropdown to not create option tags
            response(this.states, true);
          } else {
            this.dropdown.updated();
          }
          this.busyIndicator = false;
        });
      } else {
        this.lmErrorUtilService.handleViewException(dataResponse as LMError);
        this.busyIndicator = false;
      }
    },
    (error) => {
      this.busyIndicator = false;
      this.lmLoggerService.error([ 'Error in fetching list as states', this.id, error ]);
    });
  }

  private handleDataResponse(response: LMListDropdownDataResponse) {
    const states = response.data;

    for (const value of this.values) {
      const selectedStateValue = this.states.find((sv: LMStateValue) => sv.value === value);
      const addState = selectedStateValue ? !response.data.some((sv: LMStateValue) => sv.value === selectedStateValue.value) : false;
      if (addState){
        selectedStateValue.selected = true;
        states.push(selectedStateValue);
      }
    }

    const selectMore: LMStateValue = {
      value: 'NANSelection',
      label: this.lmFormatUtilService.formatMessage(Soho.Locale.translate('NumberSelected'), [ this.values.length, this.options.maxValues ]),
      disabled: true
    };

    states.push(selectMore);

    if (response.moreRecordsExists) {
      const searchToRefine: LMStateValue = {
        value: 'NANSearch',
        label: Soho.Locale.translate('RefineSearch'),
        disabled: true
      };

      states.push(searchToRefine);
    }

    this.states = states;
  }
}
